// a missing language code is treated as English
export const isNonEnglishCode = (code) => !!code && code.toLowerCase() !== 'en';

export const FIRST_DRAFT_POST_TOOLTIP = 'First Draft is available for English posts only';
export const FIRST_DRAFT_PROFILE_TOOLTIP = 'First Draft is available for English profiles only';

export const TRANSLATION_LANGUAGES = {
  en: 'English',
  pt: 'Portuguese',
  de: 'German',
  es: 'Spanish',
  fr: 'French',
};

export const TRANSLATION_UNSUPPORTED_TOOLTIP = [
  'Translation is available for English, Portuguese, German,',
  'Spanish and French job posts only',
].join(' ');

const ENGLISH_TRANSLATION_TARGETS = ['pt', 'de', 'es', 'fr'];

// English (including a missing code) can go to Portuguese, German, Spanish or French.
// A supported non-English job can only go to English. Anything else cannot be translated.
const normalizedLanguageCode = (languageCode) => {
  if (languageCode === null || languageCode === undefined) return '';
  return String(languageCode).trim().toLowerCase();
};

export const translationTargets = (languageCode) => {
  const code = normalizedLanguageCode(languageCode);

  if (!code || code === 'en') return [...ENGLISH_TRANSLATION_TARGETS];

  if (Object.prototype.hasOwnProperty.call(TRANSLATION_LANGUAGES, code)) return ['en'];

  return [];
};

export const isTranslationSupported = (languageCode) => translationTargets(languageCode).length > 0;

// Display name for a detected language. Unknown codes are shown in uppercase.
// A missing code is English.
export const translationLanguageLabel = (languageCode) => {
  const code = normalizedLanguageCode(languageCode);

  if (!code || code === 'en') return TRANSLATION_LANGUAGES.en;

  if (TRANSLATION_LANGUAGES[code]) return TRANSLATION_LANGUAGES[code];

  return String(languageCode).trim().toUpperCase();
};
